module.exports = __webpack_public_path__ + "img/unfold_less.363aaf2e.svg";